export default {
  form: {
    preparation_time: {
      label: 'Podaj własny czas (minuty):',
      placeholder: 'Podaj minuty',
    },
  },
  buttons: {
    custom: 'Własny',
  },
  feedback: {
    preparation_time_required: 'Czas przygotowania musi być większy niż 0 minut',
    min_preparation_time: 'Min. {{minutes}} min. czas przygotowania dla dostawy zewnętrznej',
    max_preparation_time: 'Maks. {{minutes}} min. czas przygotowania',
  },
};
